import type { BookingChannel } from './BookingChannelsAutocomplete.types.ts';

export const bookingOptions = [
  { id: 'staff', label: 'Scheduled by Staff' },
  { id: 'pss', label: 'Scheduled by Patient Online' },
  { id: 'import', label: 'Imported' },
] as const;

export const getOptionLabel = (bookingChannel: BookingChannel) => bookingChannel.label;
